var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRedo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h24v24H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M19.4 10.6C17.55 8.99 15.15 8 12.5 8c-4.65 0-8.58 3.03-9.96 7.22L4.9 16a8.002 8.002 0 017.6-5.5c1.95 0 3.73.72 5.12 1.88l-1.913 1.913A1 1 0 0016.414 16H23V9.414a1 1 0 00-1.707-.707L19.4 10.6z"
  }))));
}

export default SvgRedo;